import React, { useState, useEffect } from "react";
import axios from 'axios';
import { useParams, useNavigate, Link } from 'react-router-dom';
import './../styles/ecom.css';
import './../styles/ecom/categorias.css';
import * as globals from './../components/GlobalScripts.js';
import NavbarTop from './ecom/Navbartop';
import Footer from './ecom/Footer';

const Home = () => {
    let path_api = localStorage.getItem('path_api');
    const { id } = useParams();
    const [productos, setProductos] = useState([]);
    const [background_categoria, setBackground] = useState('');

    useEffect(() => {
        const fetchFacebookData = async () => {
            let facebookParams = globals.facebookParams();
            let event_source_url = facebookParams.event_source_url;
            let client_user_agent = facebookParams.client_user_agent;
            let event_time = facebookParams.event_time;
            let facebookPixel = facebookParams.facebookPixel;
            let facebookToken = facebookParams.facebookToken;
            let event_id = facebookParams.event_id;

            let data = {
                "event_source_url": event_source_url,
                "event_time": event_time,
                "client_user_agent": client_user_agent,
                "hostedBy": "Zadrig"
            };

            await window.fbq('track', 'PageView', data, { eventID: event_id });

            let fbp = facebookParams.fbp;
            let fbc = facebookParams.fbc;

            await fetch('https://zadrig.com/facebook/eventos/ecommerce.zadrigman/pageview.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    event_id: event_id,
                    facebookPixel: facebookPixel,
                    facebookToken: facebookToken,
                    event_time: event_time,
                    fbp: fbp,
                    fbc: fbc,
                    event_source_url: event_source_url,
                    client_user_agent: client_user_agent
                }),
            });
        };

        fetchFacebookData();
    }, [id]);

    useEffect(() => {
        setBackground('');
        setProductos([]);
        get_productos();
    }, [id]);

    const get_productos = async () => {
        await axios.post(`${path_api}/ecom/productos_categoria.php`, {
            rute: globals.getRuteBackend(),
            categoria: id
        }).then(response => {
            if (response.data.mensaje === "success") {
                const productosObtenidos = response.data.productos.map(producto => ({
                    id: producto.id,
                    nombre: producto.nombre,
                    precio: producto.data ? JSON.parse(producto.data).variaciones[0].precio : null,
                    imagen: producto.data ? JSON.parse(producto.data).imagenes[0].url : null,
                }));
                if (productosObtenidos.length) {
                    setProductos(productosObtenidos);
                    setBackground(productosObtenidos[0].imagen)
                } else
                    globals.createAlert({ type: "advertencia", msg_title: "Proximamente", msg: "Aun no hay productos en esta categoria", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            } else if (response.data.mensaje) {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje, effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: "No se obtuvieron los productos", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error 'log-productos-1'", msg: "Si persiste informa al soporte", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
    };

    return (
        <div className="app-ecom app-container">
            <NavbarTop />
            <div className="main-content page-categorias">
                <div className="slider">
                    <div className="slide" style={{ backgroundImage: `url(${background_categoria})` }}>
                        <div className='overlay-slider'></div>
                        <div className="content">
                            <h1>Todo en {id}</h1>
                            {id != "zadrigman" && (<p>Compras mayores a $2000 obtienen envio gratis.</p>)}
                            {id == "zadrigman" && (<p>Todos estos productos tienen envio gratis.</p>)}
                        </div>
                    </div>
                </div>
                <div className="page-container">
                    <div className='container-section flex-column gap-20'>
                        <h1 className="no-margin">Productos de la categoría</h1>

                        {productos.length > 0 ? (
                            <div className="productos-galery">
                                {productos.map(producto => (
                                    <Link to={`/productos/${producto.id}`} className="producto-card" key={producto.id}>
                                        <img src={producto.imagen} alt={producto.nombre} className="producto-imagen" loading="lazy" />
                                        <div className="content">
                                            <h5>{producto.nombre}</h5>
                                            <p>${producto.precio} MXN</p>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        ) : (
                            <p className="no-products-message"><b>Proximamente: </b>Aun hay productos disponibles en esta categoría.</p>
                        )}
                    </div>

                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Home;
